// assets/upside-cart-offer.js  (2026-10-06)
// Simon 2026-10-06: the "-10% for 30 seconds" offer, a big window that opens when the customer clicks
// Checkout in our cart drawer (assets/upside-cart.js). Replaces the Rebuy post-purchase upsell, turned off for good because
// editing an order after payment made ShipHero ship West orders twice. Here the customer adds
// BEFORE paying, so everything is one normal order.
//   - offer 1: one more of the most expensive item in the cart (Rebuy's rule that converted)
//   - offer 2: a similar product bought with it (upside-also.json), closest price
//   - only products the customer's region can ship (same inventory service as the cart)
//   - the 30 s start when the window opens; once shown, it does not come back this visit
//   - "Add" asks upside-cart-offer worker for a single-use code: buy 1 of the cart item, get 1 of the
//     offer at -10%, applied with /discount/<code>. No code (worker switched off) = added at full price.
// Never touches the product form, Add to Cart or window.fetch (1_upside-drinks/CLAUDE.md).
(function () {
  'use strict';
  if (window.UDCartOffer) return;
  var SECONDS = 30, OFF = 0.10;
  var WORKER = 'https://upside-cart-offer.gilles-577.workers.dev/offer';
  var KEY = 'ud_offer30v2';   // v2: the window version; an old 'done' from the in-cart block must not hide it
  var FR = (document.documentElement.lang || '').toLowerCase().indexOf('fr') === 0;
  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || (/^\/fr(\/|$)/.test(location.pathname) ? '/fr/' : '/');
  if (ROOT.slice(-1) !== '/') ROOT += '/';
  var T = FR ? {
    head: 'L\u2019offre se termine dans', again: 'Ton choix, encore un', like: 'Les clients adorent aussi', add: 'Ajouter au panier', save: 'Tu économises', free: '+ LIVRAISON GRATUITE',
    adding: 'Ajout...', done: 'Ajouté, -10 % appliqué au paiement', doneNoCode: 'Ajouté (mode test : sans rabais)',
    over: "L'offre de 30 secondes est terminée.", error: "L'offre n'est plus disponible."
  } : {
    head: 'Offer ends in', again: 'Your pick, one more', like: 'Customers also love', add: 'Add to cart', save: 'You save', free: '+ FREE shipping',
    adding: 'Adding...', done: 'Added, -10% applied at checkout', doneNoCode: 'Added (test mode: no discount)',
    over: 'The 30-second offer has ended.', error: 'This offer is no longer available.'
  };

  function ss(k, v) { try { if (v === undefined) return sessionStorage.getItem(k); sessionStorage.setItem(k, v); } catch (e) { return null; } }
  function state() { try { return JSON.parse(ss(KEY) || '{}') || {}; } catch (e) { return {}; } }
  function save(s) { ss(KEY, JSON.stringify(s)); }
  function money(c) { return '$' + ((c || 0) / 100).toFixed(2); }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function img(src, w) { if (!src) return ''; if (src.indexOf('//') === 0) src = 'https:' + src; return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + w; }
  function getJSON(u) { return window.fetch(u, { credentials: 'same-origin' }).then(function (r) { if (!r.ok) throw r.status; return r.json(); }); }
  function wholesale() { return typeof window.isWsgCustomer !== 'undefined' && !!window.isWsgCustomer; }
  function readLS(k) { try { return localStorage.getItem(k) || ''; } catch (e) { return ''; } }
  function region() {
    var d = (document.documentElement.dataset && document.documentElement.dataset.ecomificRegion) || '';
    var v = String(d || readLS('ecomific_region')).toLowerCase().trim();
    return v === 'east' || v === 'west' ? v : '';
  }
  function invBase() {
    var c = window.ecomificAvailabilityConfig;
    var raw = String((c && (c.endpointBase || c.inventoryApiBase)) || window.ECOMIFIC_INVENTORY_ENDPOINT_URL || '').trim().replace(/\/+$/, '');
    if (!/^https?:\/\//i.test(raw)) return '';
    if (raw.indexOf('/.netlify/functions') > -1) return /\/\.netlify\/functions$/.test(raw) ? raw + '/inventory' : raw;
    return /\/inventory$/.test(raw) ? raw : raw + '/inventory';
  }
  // how many units the region can still ship (Infinity = no limit, null = unknown)
  function regionQty(variantId) {
    var base = invBase(), reg = region();
    if (!base || !reg) return Promise.resolve(null);
    return window.fetch(base + '?variant_id=' + encodeURIComponent(variantId) + '&region=' + encodeURIComponent(reg), { credentials: 'omit' })
      .then(function (r) { if (!r.ok) throw r.status; return r.json(); })
      .then(function (a) {
        if (!a || a.ok !== true) return null;
        if (a.available !== true) return 0;
        var native = a.available_for_sale === true && (a.tracked === false || String(a.inventory_policy || '').toUpperCase() === 'CONTINUE');
        if (!native && a.quantity != null && isFinite(a.quantity)) return Math.max(0, Number(a.quantity));
        return Infinity;
      }).catch(function () { return null; });
  }
  function cookie(k) { var m = document.cookie.match(new RegExp('(?:^|; )' + k + '=([^;]*)')); return m ? decodeURIComponent(m[1]) : ''; }
  function threshold() {
    var p = '';
    try { var L = window.ecomificShoppingLocation; p = (L && L.getLocation && L.getLocation()) || ''; } catch (e) {}
    p = String(p || cookie('ecomific_shopping_location') || '').trim().toUpperCase();
    if (p === 'ON' || p === 'QC') return 7500;
    if (['AB', 'BC', 'MB', 'SK'].indexOf(p) > -1) return 12500;
    if (['NB', 'NS', 'PE', 'NL'].indexOf(p) > -1) return 15000;
    return null;
  }
  function canShip(variantId, need) { return regionQty(variantId).then(function (q) { return q === null || q >= need; }); }

  var lists = null;
  function data() {
    if (lists) return lists;
    var s = document.querySelector('script[data-also][src*="upside-cart"]');
    var also = s && s.getAttribute('data-also'), fbt = s && s.getAttribute('data-lists');
    lists = Promise.all([also ? getJSON(also).catch(function () { return {}; }) : {}, fbt ? getJSON(fbt).catch(function () { return {}; }) : {}])
      .then(function (r) { var fr = (r[1] && r[1]._fr) || {}, back = {}; for (var en in fr) back[fr[en]] = en; return { also: r[0] || {}, fr: fr, back: back }; });
    return lists;
  }
  function tagged(p, t) { return (p.tags || []).some(function (x) { return String(x).toLowerCase() === t; }); }

  // ---------- choose the two offers ----------
  function pick(cart) {
    var lines = (cart.items || []).filter(function (it) {
      var P = it.properties || {};
      return it.final_price > 0 && !P._ud_src_offer && P._ud_src !== 'offer30' && !/gift/i.test(JSON.stringify(P));
    });
    if (!lines.length) return Promise.resolve(null);
    var anchor = lines.slice().sort(function (a, b) { return b.final_price - a.final_price; })[0];
    var inCart = {}; (cart.items || []).forEach(function (it) { inCart[it.product_id] = 1; });
    var qtyInCart = (cart.items || []).filter(function (it) { return it.variant_id === anchor.variant_id; }).reduce(function (s, it) { return s + it.quantity; }, 0);
    var again = Promise.all([canShip(anchor.variant_id, qtyInCart + 1),
      getJSON(ROOT + 'products/' + anchor.handle + '.js').catch(function () { return null; })]).then(function (r) {
      if (!r[0]) return null;
      var pv = r[1] && (r[1].variants || []).filter(function (v) { return v.id === anchor.variant_id; })[0];
      return { kind: T.again, id: anchor.variant_id, title: anchor.product_title, variant: anchor.variant_title, price: anchor.final_price,
        compare: pv && pv.compare_at_price, image: anchor.image, url: anchor.url };
    });
    var similar = data().then(function (d) {
      var en = d.back[anchor.handle] || anchor.handle, reg = region();
      var cands = (d.also[en] || []).slice(0, 8);
      var step = function (i) {
        if (i >= cands.length) return null;
        var a = String(cands[i]).split('|'), h = a[0], r = a[1] || '';
        if (r && reg && ((r === 'e' && reg !== 'east') || (r === 'w' && reg !== 'west'))) return step(i + 1);
        return getJSON(ROOT + 'products/' + ((FR && d.fr[h]) || h) + '.js').catch(function () { return null; }).then(function (p) {
          if (!p || !p.available || inCart[p.id] || tagged(p, 'dev-product')) return step(i + 1);
          if ((reg === 'east' && tagged(p, 'west-only')) || (reg === 'west' && tagged(p, 'east-only'))) return step(i + 1);
          var vs = (p.variants || []).filter(function (v) { return v.available; })
            .sort(function (x, y) { return Math.abs(x.price - anchor.final_price) - Math.abs(y.price - anchor.final_price); });
          if (!vs.length) return step(i + 1);
          return canShip(vs[0].id, 1).then(function (ok) {
            if (!ok) return step(i + 1);
            var v = vs[0];
            return { kind: T.like, id: v.id, title: p.title, variant: v.title === 'Default Title' ? '' : v.title, price: v.price, compare: v.compare_at_price,
              image: (v.featured_image && v.featured_image.src) || p.featured_image, url: p.url };
          });
        });
      };
      return step(0);
    });
    return Promise.all([again, similar]).then(function (r) {
      var offers = r.filter(Boolean);
      return offers.length ? { anchor: anchor.variant_id, offers: offers, total: cart.total_price } : null;
    });
  }

  // ---------- UI: a big window when the customer clicks Checkout (Simon 2026-10-06: "a big pop-up right
  // in their face" was what made Rebuy's offer work). Shown once per visit; "Continue to checkout" is
  // always there, so nobody is ever stuck on it.
  var css = [
    '#ud-offer{position:fixed;inset:0;z-index:2147483600;display:flex;align-items:center;justify-content:center;padding:16px;background:rgba(17,24,39,.6)}',
    '#ud-offer .ud-offer__card{background:#fff;width:100%;max-width:460px;border-radius:14px;padding:22px 20px 18px;box-shadow:0 20px 60px rgba(0,0,0,.3);display:flex;flex-direction:column;gap:14px;max-height:calc(100vh - 32px);overflow:auto;font-family:inherit;color:#202A36;animation:udOfferIn .25s ease}',
    '@keyframes udOfferIn{from{transform:translateY(16px) scale(.98);opacity:0}to{transform:none;opacity:1}}',
    '@media (prefers-reduced-motion:reduce){#ud-offer .ud-offer__card{animation:none}}',
    '@media (max-width:520px){#ud-offer{padding:0;align-items:flex-end}#ud-offer .ud-offer__card{max-width:none;border-radius:16px 16px 0 0;max-height:92vh;padding-bottom:calc(18px + env(safe-area-inset-bottom,0px))}}',
    '.ud-offer__band{margin:-22px -20px 0;background:#E3262B;color:#fff;border-radius:14px 14px 0 0;padding:16px 20px 14px;text-align:center}',
    '.ud-offer__title{margin:0;font-size:24px;font-weight:800;letter-spacing:.04em;color:#fff;display:flex;align-items:center;justify-content:center;gap:8px;animation:udOfferPop .5s ease .1s both}',
    '.ud-offer__title svg{width:22px;height:22px;flex:none;fill:#FFD43B}',
    '@keyframes udOfferPop{0%{transform:scale(.8);opacity:0}60%{transform:scale(1.08);opacity:1}100%{transform:scale(1)}}',
    '@media (prefers-reduced-motion:reduce){.ud-offer__title{animation:none}}',
    '@media (max-width:520px){.ud-offer__band{border-radius:16px 16px 0 0}.ud-offer__title{font-size:19px;letter-spacing:.02em;gap:6px}.ud-offer__title svg{width:18px;height:18px}}',
    '.ud-offer__sub{margin:6px 0 0;text-align:center;font-size:14px;color:#fff;opacity:.92}',
    '.ud-offer__h{display:flex;flex-direction:column-reverse;align-items:center;gap:0;background:#fdeaea;color:#E3262B;border:1px solid #f8c3c4;border-radius:10px;padding:8px 12px 10px;text-align:center}',
    '.ud-offer__h span:first-child{font-size:12px;font-weight:600;letter-spacing:.04em;text-transform:uppercase;opacity:.85}',
    '.ud-offer__clock{color:#E3262B;font-weight:800;font-variant-numeric:tabular-nums;font-size:40px;line-height:1.05}',
    '.ud-offer__bar{height:6px;background:#f8c3c4;border-radius:3px;overflow:hidden;margin-top:6px}',
    '.ud-offer__bar i{display:block;height:100%;width:100%;background:#E3262B}',
    '.ud-offer__row{display:grid;grid-template-columns:84px 1fr;gap:12px;align-items:center;border:2px solid #e6e8ee;border-radius:12px;padding:10px;margin-top:10px}',
    '.ud-offer__row.is-top{border-color:#E3262B;background:#fff7f7}',
    '.ud-offer__pic{position:relative;width:84px;height:84px}',
    '.ud-offer__badge{position:absolute;top:-6px;left:-6px;background:#E3262B;color:#fff;font-weight:800;font-size:12px;border-radius:50px;padding:3px 7px}',
    '.ud-offer__save{color:#1e8449;font-weight:700;font-size:12px;margin-top:2px}',
    '.ud-offer__free{display:inline-block;margin-top:4px;background:#e8f5ee;color:#1e8449;font-weight:800;font-size:11px;letter-spacing:.04em;border-radius:50px;padding:2px 8px}',
    '.ud-offer__add{margin-top:8px;width:100%}',
    '.ud-offer__clock.is-hot{animation:udOfferPulse .6s ease-in-out infinite alternate}',
    '@keyframes udOfferPulse{from{opacity:1}to{opacity:.35}}',
    '.ud-offer__row img{width:84px;height:84px;object-fit:contain;border-radius:8px;background:#fff}',
    '.ud-offer__t{font-size:14px;line-height:1.3;min-width:0}',
    '.ud-offer__k{display:block;font-size:10px;font-weight:700;letter-spacing:.06em;text-transform:uppercase;color:#6b7185;margin-bottom:2px}',
    '.ud-offer__p{font-size:14px;font-variant-numeric:tabular-nums;margin-top:3px}',
    '.ud-offer__p s{color:#6b7185}.ud-offer__p b{color:#E3262B;font-size:16px}',
    '.ud-offer__pct{display:inline-block;margin-left:6px;background:#E3262B;color:#fff;font-weight:800;font-size:13px;border-radius:50px;padding:2px 8px;vertical-align:1px}',
    '.ud-offer__add{border:0;border-radius:50px;background:#2883FD;color:#fff;font-weight:700;font-size:14px;padding:10px 18px;cursor:pointer;white-space:nowrap}',
    '.ud-offer__add:disabled{opacity:.6;cursor:default}',
    '.ud-offer__go{border:2px solid #37446E;border-radius:50px;background:#fff;color:#37446E;font-weight:700;font-size:15px;letter-spacing:.03em;padding:12px;cursor:pointer;width:100%}',
    '.ud-offer__skip{border:0;background:none;color:#6b7185;font-size:13px;text-decoration:underline;cursor:pointer;align-self:center;padding:4px}',
    '#ud-offer .ud-offer__skip[hidden]{display:none!important}',
    '.ud-offer__msg{font-size:15px;color:#1e8449;font-weight:700;text-align:center}',
    '.ud-offer__msg.is-off{color:#6b7185;font-weight:500}',
    '#ud-offer button:focus-visible{outline:2px solid #37446E;outline-offset:2px}'
  ].join('');
  if (FR) { T.title = 'OFFRE ÉCLAIR DÉBLOQUÉE'; T.sub = '10 % de rabais en plus · 30 secondes seulement'; T.go = 'Continuer vers le paiement'; T.skip = 'Non merci, je préfère payer le plein prix'; }
  else { T.title = 'FLASH DEAL UNLOCKED'; T.sub = 'Extra 10% off · 30 seconds only'; T.go = 'Continue to checkout'; T.skip = 'No thanks, I\u2019ll pay full price'; }

  var modal = null, timer = null, current = null, busy = false, ready = null;
  function goCheckout() {
    var s = state(); s.done = 1; save(s);
    clearInterval(timer); timer = null;
    window.location.href = ROOT + 'checkout';
  }
  function close() { clearInterval(timer); timer = null; if (modal && modal.parentNode) modal.parentNode.removeChild(modal); modal = null; document.removeEventListener('keydown', onKey, true); }
  function onKey(e) { if (e.key === 'Escape') { e.preventDefault(); goCheckout(); } }
  function ended(msg, off) {
    var s = state(); s.done = 1; save(s);
    clearInterval(timer); timer = null;
    if (!modal) return;
    var body = modal.querySelector('.ud-offer__body');
    if (body) body.innerHTML = '<p class="ud-offer__msg' + (off ? ' is-off' : '') + '">' + esc(msg) + '</p>';
    var skip = modal.querySelector('.ud-offer__skip'); if (skip) skip.hidden = true;
  }
  function paint() {
    if (!modal) return;
    var s = state(); if (!s.start) return;
    var left = Math.max(0, s.start + SECONDS * 1000 - Date.now());
    var c = modal.querySelector('.ud-offer__clock'), b = modal.querySelector('.ud-offer__bar i');
    if (c) { c.textContent = '0:' + String(Math.ceil(left / 1000)).padStart(2, '0'); c.classList.toggle('is-hot', left > 0 && left <= 10000); }
    if (b) b.style.width = (left / (SECONDS * 10)) + '%';
    if (left <= 0 && !busy) ended(T.over, true);
  }
  function open(o) {
    if (!document.getElementById('ud-offer-css')) { var st = document.createElement('style'); st.id = 'ud-offer-css'; st.textContent = css; document.head.appendChild(st); }
    current = o;
    var s = state(); s.start = Date.now(); save(s);
    modal = document.createElement('div');
    modal.id = 'ud-offer';
    modal.setAttribute('role', 'dialog'); modal.setAttribute('aria-modal', 'true'); modal.setAttribute('aria-labelledby', 'UDOfferTitle');
    modal.innerHTML = '<div class="ud-offer__card">' +
      '<div class="ud-offer__band"><p class="ud-offer__title" id="UDOfferTitle">' + '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M13 2 3 14h7l-1 8 10-12h-7z"/></svg>' + esc(T.title) + '</p><p class="ud-offer__sub">' + esc(T.sub) + '</p></div>' +
      '<div class="ud-offer__body"><div class="ud-offer__h"><span>' + esc(T.head) + '</span><span class="ud-offer__clock">0:30</span></div>' +
      '<div class="ud-offer__bar"><i></i></div>' +
      o.offers.map(function (x, i) {
        // Shopify rounds a percentage discount DOWN (10% of 27.99 = 2.79), so show exactly that
        var now = x.price - Math.floor(x.price * OFF), goal = threshold();
        // count from the regular price the site already shows struck through (compare-at), when there is one
        var was = Math.max(x.price, Number(x.compare) || 0), pct = Math.round((was - now) / was * 100);
        var free = goal && o.total < goal && o.total + now >= goal;
        return '<div class="ud-offer__row' + (i === 0 ? ' is-top' : '') + '"><div class="ud-offer__pic">' + (x.image ? '<img src="' + esc(img(x.image, 200)) + '" alt="" loading="lazy">' : '') +
          '</div>' +
          '<div class="ud-offer__t"><span class="ud-offer__k">' + esc(x.kind) + '</span>' + esc(x.title) + (x.variant ? ' &middot; ' + esc(x.variant) : '') +
          '<div class="ud-offer__p"><s>' + money(was) + '</s> <b>' + money(now) + '</b><span class="ud-offer__pct">-' + pct + '%</span></div>' +
          '<div class="ud-offer__save">' + esc(T.save) + ' ' + money(was - now) + '</div>' +
          (free ? '<span class="ud-offer__free">' + esc(T.free) + '</span>' : '') +
          '<button type="button" class="ud-offer__add" data-offer="' + i + '">' + esc(T.add) + '</button></div></div>';
      }).join('') + '</div>' +
      '<button type="button" class="ud-offer__go">' + esc(T.go) + '</button>' +
      '<button type="button" class="ud-offer__skip">' + esc(T.skip) + '</button></div>';
    document.body.appendChild(modal);
    modal.addEventListener('click', function (e) {
      var a = e.target.closest('.ud-offer__add');
      if (a) return accept(+a.getAttribute('data-offer'));
      if (e.target.closest('.ud-offer__go') || e.target.closest('.ud-offer__skip') || e.target === modal) goCheckout();
    });
    document.addEventListener('keydown', onKey, true);
    setTimeout(function () { var f = modal && modal.querySelector('.ud-offer__add'); if (f) f.focus({ preventScroll: true }); }, 50);
    timer = setInterval(paint, 250); paint();
    // anonymous +1 for the 2-week report (views vs codes): no id, no cookie
    try { window.fetch(WORKER.replace(/\/offer$/, '/seen'), { method: 'POST', keepalive: true }).catch(function () {}); } catch (e) {}
  }
  function accept(i) {
    var o = current && current.offers[i]; if (!o || busy || !modal) return;
    var s = state(); if (!s.start || Date.now() > s.start + SECONDS * 1000) return ended(T.over, true);
    busy = true;
    modal.querySelectorAll('.ud-offer__add').forEach(function (b) { b.disabled = true; });
    var btn = modal.querySelector('[data-offer="' + i + '"]'); if (btn) btn.textContent = T.adding;
    window.fetch(WORKER, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ buy: String(current.anchor), get: String(o.id) }) })
      .then(function (r) { return r.ok ? r.json() : { error: r.status }; })
      .catch(function () { return { error: 'network' }; })
      .then(function (res) {
        if (res.error) { busy = false; return ended(T.error, true); }
        // add to the cart without opening the drawer behind the window
        return window.fetch(ROOT + 'cart/add.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-UD-Cart': '1' },
          body: JSON.stringify({ items: [{ id: o.id, quantity: 1, properties: { _ud_src: 'offer30' } }] }) })
          .then(function (r) { if (!r.ok) throw r.status; })
          .then(function () {
            if (!res.code) return;
            return window.fetch(ROOT + 'discount/' + encodeURIComponent(res.code) + '?redirect=' + encodeURIComponent(ROOT + 'cart.js'), { credentials: 'same-origin' }).catch(function () {});
          })
          .then(function () {
            busy = false; ended(res.code ? T.done : T.doneNoCode);
            try { window.UDCart && window.UDCart.refresh && window.UDCart.refresh(); document.dispatchEvent(new CustomEvent('ud:cart.change', { detail: { source: 'offer30' } })); } catch (e) {}
          });
      })
      .catch(function () { busy = false; ended(T.error, true); });
  }

  // offers are chosen when the cart opens or changes, so the click on Checkout opens the window instantly
  var evalKey = '';
  var pending = null;
  function prepare() {
    if (wholesale() || state().done) { ready = null; return Promise.resolve(null); }
    pending = getJSON(ROOT + 'cart.js').then(function (cart) {
      if (!cart || !cart.items || !cart.items.length) { ready = null; return null; }
      var key = cart.items.map(function (it) { return it.variant_id + 'x' + it.quantity; }).join(',') + '|' + region();
      if (key === evalKey && ready) return ready;
      evalKey = key; ready = null;
      return pick(cart).then(function (o) { if (key === evalKey) ready = o; return ready; });
    }).catch(function () { return null; });
    return pending;
  }
  // capture phase, before the drawer's own Checkout handler; only the drawer's Checkout button
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('#ud-cart [data-checkout]');
    if (!b || modal || state().done || wholesale()) return;
    e.preventDefault(); e.stopPropagation();
    if (ready) return open(ready);
    // clicked before the offers were ready: wait for them, at most 3 s, then go to checkout as usual
    var gone = false;
    var go = setTimeout(function () { gone = true; goCheckout(); }, 3000);
    (pending || prepare()).then(function () { return ready || prepare(); }).then(function (o) {
      if (gone) return; clearTimeout(go);
      if (o && !state().done) open(o); else goCheckout();
    });
  }, true);
  document.addEventListener('ud:cart.open', function () { setTimeout(prepare, 300); });
  document.addEventListener('ud:cart.change', function () { if (!busy) setTimeout(prepare, 400); });
  // get ready in the background as soon as the page is idle: the co-purchase lists are big, and a
  // customer who opens the cart and clicks Checkout right away must still see the window
  function warm() { if (wholesale()) return; data(); prepare(); }
  if (document.readyState === 'complete') setTimeout(warm, 1500);
  else window.addEventListener('load', function () { setTimeout(warm, 1500); });
  window.UDCartOffer = { prepare: prepare, reset: function () { ss(KEY, '{}'); evalKey = ''; ready = null; close(); } };
})();
